import vue from 'vue';
import {mapState} from 'vuex';

export default{
	name: 'SideBar',
	data() {
		return {
			model: false,
			isTop: true
		}
	},
	computed: mapState({
		city: state => state.home.city,
		commons: state => state.home.commons
	}),
	watch: {
		$route() {
             this.judge();
        }
	},
	methods: {
		meiqiaClick() {
			let stater = this.$store.state;
			let obj = {
				'consult_from': this.$route.name == 'Home' ? '首页侧边栏在线咨询' : '我的预约纪录页浮窗在线咨询',
				'locate_city': stater.home.city.city_name,
				'user_grade': stater.course.grade.name || '三年级'
			};
			_MEIQIA('showPanel');
			utils.bury('yd_izhikang_headpage_side_online_consult', obj);
		},
		phoneCall() {
			let stater = this.$store.state;
			let obj = {
				'page_view': this.$route.name == 'Home' ? '首页' : '我的预约记录页',
				'locate_city': stater.home.city.city_name,
				'user_grade': stater.course.grade.name || '三年级',
				'user_tel_no': stater.mine.state.mobile || ''
			};
			utils.bury('yd_izhikang_headpage_side_tel_consult', obj);

		window.location.href = 'tel:4008102680';
		},
    judge() {
      let route = this.$route.name;

      if (route == 'courseGo' || route == "ordered") {
        this.isTop = false;
      } else {
        this.isTop = true;
      }
    },
    isShowSideBar(isShowSideBar) {
      this.model = isShowSideBar;
    },
    top() {
      this.goTop();
    }
  },
  mounted() {
    this.$store.dispatch('fetchCommons');
    vue.prototype.isShowSideBar = this.isShowSideBar;
  }
}


// WEBPACK FOOTER //
// ./src/components/public/sideBar/SideBarVM.js